import React, { Component } from "react";
import { connect } from "react-redux";
import { updateLoadMeasuring } from "../actions/";

class PaintFinish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      lmMain: {},
      introText: ""
    };
    this.handleOnchange = this.handleOnchange.bind(this);
    this.handleOnSubOptionchange = this.handleOnSubOptionchange.bind(this);
  }

  handleOnchange = selected => {
    if (JSON.parse(selected.target.value).orderCode === "00") {
      this.props.loadMeasureSelect(JSON.parse(selected.target.value));
      this.setState({
        lmMain: "00"
      });
    } else {
      this.setState(
        {
          lmMain: JSON.parse(selected.target.value)
        },
        () => {
          var loadMeasuring = {
            main: this.state.lmMain,
            sub: ""
          };
          this.props.loadMeasureSelect(loadMeasuring);
        }
      );
    }
  };

  handleOnSubOptionchange = selected => {
    var loadMeasuring = {
      main: this.state.lmMain,
      sub: selected,
      orderCodeForPdf: this.state.lmMain.orderCode + "X",
      orderCode: this.state.lmMain.orderCode + selected.orderCode
    };

    if (
      (loadMeasuring.orderCode === "20" ||
        loadMeasuring.orderCode === "21" ||
        loadMeasuring.orderCode === "30" ||
        loadMeasuring.orderCode === "31") &&
      (this.props.winchType.orderCode === "02" ||
        this.props.winchType.orderCode === "04" ||
        this.props.winchType.orderCode === "05") &&
      this.props.mType === "metric"
    ) {
      loadMeasuring = {
        ...loadMeasuring,
        weight: 2.2
      };
    } else if (
      (loadMeasuring.orderCode === "40" ||
        loadMeasuring.orderCode === "41" ||
        loadMeasuring.orderCode === "42" ||
        loadMeasuring.orderCode === "30" ||
        loadMeasuring.orderCode === "31") &&
      (this.props.winchType.orderCode === "02" ||
        this.props.winchType.orderCode === "04" ||
        this.props.winchType.orderCode === "05") &&
      this.props.mType === "metric"
    ) {
      loadMeasuring = {
        ...loadMeasuring,
        weight: 1.2
      };
    } else if (
      (loadMeasuring.orderCode === "20" ||
        loadMeasuring.orderCode === "21" ||
        loadMeasuring.orderCode === "30" ||
        loadMeasuring.orderCode === "31") &&
      this.props.winchType.orderCode === "01" &&
      this.props.mType === "metric"
    ) {
      loadMeasuring = {
        ...loadMeasuring,
        weight: 1.2
      };
    } else if (
      (loadMeasuring.orderCode === "40" ||
        loadMeasuring.orderCode === "41" ||
        loadMeasuring.orderCode === "42" ||
        loadMeasuring.orderCode === "30" ||
        loadMeasuring.orderCode === "31") &&
      this.props.winchType.orderCode === "02" &&
      this.props.mType === "metric"
    ) {
      loadMeasuring = {
        ...loadMeasuring,
        weight: 1.2
      };
    } else {
      loadMeasuring = {
        ...loadMeasuring,
        weight: 0
      };
    }
    this.props.loadMeasureSelect(loadMeasuring);
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.previewStatus !== this.props.previewStatus ||
      prevProps.mType !== this.props.mType ||
      prevProps.ropeEndControl !== this.props.ropeEndControl
    ) {
      if (this.props.previewStatus === null) {
        this.setState({
          lmMain: this.props.loadMeasuring.main
        });
      }
      if (this.props.mType !== "imperial") {
        this.setState({
          introText: ""
        });
      } else {
        this.setState({
          introText: "Only available in metric version."
        });
      }
      if (
        this.props.ropeEndControl.orderCode !== "00" &&
        this.props.mType === "metric"
      ) {
        this.setState({
          show: true,
          lmMain:
            this.props.loadMeasuring.orderCode !== "00"
              ? this.props.loadMeasuring.main
              : {}
        });
      } else {
        this.props.loadMeasureSelect({
          orderCode: "00",
          value: "Without MCD",
          weight: 0
        });
        this.setState({
          show: false
        });
      }
    }
  }

  render() {
    var option125 = [];
    option125.push(
      {
        name: "load_measuring_options",
        value: "With crimped cable ends, 6 lines",
        orderCode: "0"
      },
      {
        name: "load_measuring_options",
        value: 'With cable and plug "Deutsch" type, 6 lines',
        orderCode: "1"
      }
    );
    var option4 = [];
    option4.push(...option125, {
      name: "load_measuring_options",
      value: 'With cable and plug "Sure Seal" type, 3 lines',
      orderCode: "2"
    });

    return (
      <div>
        {this.state.show && (
          <div>
            <div className="field-top">Load measuring</div>
            <div className="selection-body">
              <p>
                The ROTZLER MCD system offers enhanced safety when operating
                TITAN winches. It measures torque to calculate the load on the
                winch. The linear signal from the MCD can be used to stop the
                system when a set point is reached. Only available when pressure
                roller and rope end control option are selected.
                <br />
                {this.state.introText}
              </p>
              <div className="row" onChange={this.handleOnchange.bind(this)}>
                <div className="col-md-6">
                  <label>
                    <input
                      type="radio"
                      value={JSON.stringify({
                        value: "Without MCD",
                        orderCode: "00"
                      })}
                      defaultChecked={
                        this.props.loadMeasuring.orderCode === "00"
                      }
                      name="load_measuring_main"
                    />{" "}
                    {"Without MCD"}
                  </label>
                </div>
                <div className="col-md-6">
                  <label>
                    <input
                      type="radio"
                      value={JSON.stringify({
                        value:
                          "MCD Step 2 - Overload 1 point sensoring @ rope in",
                        orderCode: "2"
                      })}
                      defaultChecked={
                        this.props.loadMeasuring.main
                          ? this.props.loadMeasuring.main.orderCode === "2"
                          : false
                      }
                      name="load_measuring_main"
                    />{" "}
                    {"MCD Step 2 - Overload 1 point sensoring @ rope in"}
                  </label>
                  {this.state.lmMain && this.state.lmMain.orderCode === "2" && (
                    <SubOptions
                      options={option125}
                      lmMain="2"
                      lmOrderCode={this.props.loadMeasuring.orderCode}
                      subOptionSelect={selectedSubOption => {
                        this.handleOnSubOptionchange(selectedSubOption);
                      }}
                    />
                  )}
                </div>
                <div className="col-md-6">
                  <label>
                    <input
                      type="radio"
                      value={JSON.stringify({
                        value:
                          "MCD Step 3 - Overload 2 point sensoring @ rope in",
                        orderCode: "3"
                      })}
                      name="load_measuring_main"
                      defaultChecked={
                        this.props.loadMeasuring.main
                          ? this.props.loadMeasuring.main.orderCode === "3"
                          : false
                      }
                    />{" "}
                    {"MCD Step 3 - Overload 2 point sensoring @ rope in"}
                  </label>
                  {this.state.lmMain && this.state.lmMain.orderCode === "3" && (
                    <SubOptions
                      options={option125}
                      lmMain="3"
                      lmOrderCode={this.props.loadMeasuring.orderCode}
                      subOptionSelect={selectedSubOption => {
                        this.handleOnSubOptionchange(selectedSubOption);
                      }}
                    />
                  )}
                </div>
                <div className="col-md-6">
                  <label>
                    <input
                      type="radio"
                      value={JSON.stringify({
                        value: "MCD Step 4 - combined rope end & torque signal",
                        orderCode: "4"
                      })}
                      name="load_measuring_main"
                      defaultChecked={
                        this.props.loadMeasuring.main
                          ? this.props.loadMeasuring.main.orderCode === "4"
                          : false
                      }
                    />{" "}
                    {"MCD Step 4 - combined rope end & torque signal"}
                  </label>
                  {this.state.lmMain && this.state.lmMain.orderCode === "4" && (
                    <SubOptions
                      options={option4}
                      lmMain="4"
                      lmOrderCode={this.props.loadMeasuring.orderCode}
                      subOptionSelect={selectedSubOption => {
                        this.handleOnSubOptionchange(selectedSubOption);
                      }}
                    />
                  )}
                </div>
                <div className="col-md-6">
                  <label>
                    <input
                      type="radio"
                      value={JSON.stringify({
                        value:
                          "MCD Step 5 - separated rope end & torque signal",
                        orderCode: "5"
                      })}
                      name="load_measuring_main"
                      defaultChecked={
                        this.props.loadMeasuring.main
                          ? this.props.loadMeasuring.main.orderCode === "5"
                          : false
                      }
                    />{" "}
                    {"MCD Step 5 - separated rope end & torque signal"}
                  </label>
                  {this.state.lmMain && this.state.lmMain.orderCode === "5" && (
                    <SubOptions
                      options={option125}
                      lmMain="5"
                      lmOrderCode={this.props.loadMeasuring.orderCode}
                      subOptionSelect={selectedSubOption => {
                        this.handleOnSubOptionchange(selectedSubOption);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {!this.state.show && (
          <div>
            <div className="field-top">Load measuring</div>
            <div className="selection-body">
              <p>
                The ROTZLER MCD system offers enhanced safety when operating
                TITAN winches. It measures torque to calculate the load on the
                winch. The linear signal from the MCD can be used to stop the
                system when a set point is reached. Only available when pressure
                roller and rope end control option are selected.
                <br />
                {this.state.introText}
              </p>
              <div className="row" onChange={this.handleOnchange.bind(this)}>
                <div className="col-md-6">
                  <label>
                    <input
                      type="radio"
                      value={JSON.stringify({
                        value: "Without MCD",
                        orderCode: "00"
                      })}
                      defaultChecked={true}
                      name="load_measuring_main"
                    />{" "}
                    {"Without MCD"}
                  </label>
                </div>
                <div className="col-md-6">
                  <label className="disabled_label">
                    <input
                      type="radio"
                      disabled
                      value={JSON.stringify({
                        value:
                          "MCD Step 2 - Overload 1 point sensoring @ rope in",
                        orderCode: "2"
                      })}
                      name="load_measuring_main"
                    />{" "}
                    {"MCD Step 2 - Overload 1 point sensoring @ rope in"}
                  </label>
                </div>
                <div className="col-md-6">
                  <label className="disabled_label">
                    <input
                      type="radio"
                      disabled
                      value={JSON.stringify({
                        value:
                          "MCD Step 3 - Overload 2 point sensoring @ rope in",
                        orderCode: "3"
                      })}
                      name="load_measuring_main"
                    />{" "}
                    {"MCD Step 3 - Overload 2 point sensoring @ rope in"}
                  </label>
                </div>
                <div className="col-md-6">
                  <label className="disabled_label">
                    <input
                      type="radio"
                      disabled
                      value={JSON.stringify({
                        value: "MCD Step 4 - combined rope end & torque signal",
                        orderCode: "4"
                      })}
                      name="load_measuring_main"
                    />{" "}
                    {"MCD Step 4 - combined rope end & torque signal"}
                  </label>
                </div>
                <div className="col-md-6">
                  <label className="disabled_label">
                    <input
                      type="radio"
                      disabled
                      value={JSON.stringify({
                        value:
                          "MCD Step 5 - separated rope end & torque signal",
                        orderCode: "5"
                      })}
                      name="load_measuring_main"
                    />{" "}
                    {"MCD Step 5 - separated rope end & torque signal"}
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

class SubOptions extends Component {
  constructor(props) {
    super(props);
    this.handleSubOnchange = this.handleSubOnchange.bind(this);
  }

  handleSubOnchange = selected => {
    selected.stopPropagation();

    this.props.subOptionSelect(JSON.parse(selected.target.value));
  };

  render() {
    return (
      <div className="subSelection" onChange={this.handleSubOnchange}>
        {this.props.options.map((option, i) => {
          return (
            <label key={i}>
              <input
                type="radio"
                value={JSON.stringify(option)}
                name={option.name}
                defaultChecked={
                  this.props.lmOrderCode ===
                  this.props.lmMain + option.orderCode
                }
              />{" "}
              {option.value}
            </label>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mType: state.mType,
    winchType: state.winchType,
    ropeEndControl: state.ropeEndControl,
    previewStatus: state.previewStatus,
    loadMeasuring: state.loadMeasuring,
    pressureRoller: state.pressureRoller
  };
};

const mapActionsToProps = {
  loadMeasureSelect: updateLoadMeasuring
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(PaintFinish);



// WEBPACK FOOTER //
// ./src/components/loadMeasuring.js